module.exports = __webpack_public_path__ + "static/media/sqrs.de13f015.svg";